const $ = require("jquery");
const Cookies = require('js-cookie');
// Fonctions pour les cookies
function setCookie(cname, cvalue, exdays) {
    let d = new Date();
    d.setTime(d.getTime() + (exdays * 300 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    Cookies.set(cname, cvalue, { expires: 300, path: '/' });
}
function getCookie(cname) {
    return Cookies.get(cname)
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


// Gestion des clics sur les boutons .pin
$(document).on('click', '.pin', function (e) {
    e.preventDefault();
    e.stopPropagation();

    const $pin = $(this);

    // Essaye de récupérer en priorité un ID de variation
    let variationId = $pin.closest('[data-variation-id]').data('variation-id');
    let productId = variationId || $pin.closest('[data-interplast-product]').data('interplast-product') || $pin.closest('[data-product-id]').data('product-id');

    // Si aucune variation détectée et le produit est variable => on empêche l’ajout
    const isVariableProduct = $pin.closest('.product-item').hasClass('product-type-variable');

    console.log('isVariableProduct', isVariableProduct);
    console.log('variationId', variationId);
    console.log('productId', productId);

    if (!variationId && isVariableProduct) {
        console.warn('Impossible d\'ajouter le produit principal à la wishlist. Choisissez une variation.');
        return;
    }

    if (productId) {
        fitt_toggleWishlist(productId, $pin);

        // Suppression visuelle si on est sur la page wishlist
        const $fav = $pin.closest('.fav-item');
        if ($fav.length) {
            $fav.fadeOut(300, function () { $(this).remove(); });
        }
    } else {
        console.warn('Impossible de détecter l\'ID produit.', $pin);
    }
});

$(document).ready(function () {
    fitt_refreshWishlist();

    if (window.innerWidth < 992 || $('body').hasClass('single')) {
        $('.pin-add .pin').on('click', function (e) {
            e.preventDefault(e);
            $(this).toggleClass('active');
        });
    }
    $('.pin-add .pin').on('mouseover', function () {
        $(this).next('.add').addClass('hovered');
    });

    $('.pin-add').on('mouseleave', function () {
        $(this).children('.add').removeClass('hovered');
    });

    // updata price in wishlist page 
    $('.fav-item #quantity').on('change', function () {

        const ctx = $(this).closest('.fav-item');

        $quantity = $(this).children("option:selected").val();
        $price = $(this).parent('.quantity').parent('.p-name').prev('.p-img').data('price');

        $price = ctx.data('price')
        $total = $price * $quantity;
        $totalText = (new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' })).format($total)
        $total = $total.toFixed(2);

        $total = String($total).replace('.', ',');

        $(this).closest('.p-name').prev('.p-img').children('.left-box').children('.bold').replaceWith('<p class="bold">' + $totalText + ' HT</p>')
    })

    //add to cart wish element
    $('.fav-item .cta-btn-wrapper').on('click', function (e) {
        e.preventDefault();

        const ctx = $(this).closest('.fav-item');
        productId = ctx.data('productid');
        quantity = parseInt($('select', ctx).val())

        console.log('lalala')
        console.log(quantity)

        if (quantity > 0) {
            const ctx = $('.fav-content');
            ctx.addClass('loading')

            $.ajax({
                type: 'POST',
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
                data: {
                    product_id: productId,
                    quantity: quantity
                },
                complete: function (response) {
                    ctx.removeClass('loading')
                    window.location.href = wc_add_to_cart_params.cart_url

                }
            });
        } else {
            const ctx = $(this).closest('.fav-item');
            const target = $('select', ctx);
            target.addClass('has-error')
        }
    });

    $('.fav-item select').change(function () {
        const t = $(this);
        if (t.hasClass('has-error')) {
            t.removeClass('has-error')
        }
        $('.error-no-quantity').hide()
    })

    //add to cart wish list
    $('.add_all_fav_to_cart').on('click', function (e) {
        e.preventDefault();
        const ctx = $('.fav-content');

        let productsToAddToCart = [];
        $('.fav-item_buyable').each(function () {
            const t = $(this);
            const productId = t.data('productid');
            const qty = parseInt($('select[name="q"]', t).val());
            if (!isNaN(qty) && qty > 0) {
                productsToAddToCart.push({
                    productId: productId,
                    qty: qty
                })
            }
        });

        if (productsToAddToCart.length === 0) {

            $('.error-no-quantity').show();

            return;
        }

        ctx.addClass('loading')

        const bulkUrl = wc_add_to_cart_params.wc_ajax_url.toString().replace("%%endpoint%%", "interplast_api_bulk_add_to_cart");
        $.post(bulkUrl, { items: productsToAddToCart }, function (r) {
            document.location.href = r.redirect_to;
            ctx.removeClass('loading')
        })
    });
});

function fitt_getWishlist() {
    let cookieWishlist = getCookie('interplast_wishlist') ?? '';
    return cookieWishlist.split(',').filter(function (e) {
        return e !== "";
    });
}
function fitt_isInWishlist(productId) {

    fitt_refreshWishlist(productId)
}

function fitt_addToWishlist(productId) {

    fitt_refreshWishlist(productId)
}

function fitt_removeFromWishlist(productId) {

    fitt_refreshWishlist(productId)
}

function fitt_refreshWishlist(productId) {
    const wishlist = fitt_getWishlist();

    // Mise à jour des thumbs
    $('.fitt-product-thumbnail').removeClass('is-in-wishlist');
    wishlist.forEach(function (w, wIndex) {
        $('.fitt-product-thumbnail[data-product-id="' + w + '"]').addClass('is-in-wishlist')
    })

    if (wishlist.length > 0) {
        $('.wishlist-count').html(wishlist.length).show();
    } else {
        $('.wishlist-count').hide();
    }

}

$(document).on('click', '.delete-all', function (e) {
    e.preventDefault();
    e.stopPropagation();

    // Confirmer la suppression avec SweetAlert
    Swal.fire({
        title: 'Êtes-vous sûr ?',
        text: "Vous allez supprimer tous les produits de votre wishlist !",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Oui, tout supprimer !',
        cancelButtonText: 'Annuler'
    }).then((result) => {
        if (result.isConfirmed) {
            // Envoie une requête AJAX pour supprimer tous les produits
            $.ajax({
                url: '/wp-admin/admin-ajax.php',  // Assurez-vous que 'fitt_ajax.ajax_url' est bien défini
                method: 'POST',
                data: {
                    action: 'fitt_delete_all_wishlist'
                },
                success: function (response) {
                    if (response.success) {
                        // Si la suppression est réussie, on efface tous les éléments de la page et du cookie
                        $('.fav-item').fadeOut(300, function () {
                            $(this).remove();
                        });
                        setCookie('interplast_wishlist', '', -1); // Supprimer le cookie de la wishlist
                        Swal.fire(
                            'Supprimé!',
                            'Votre wishlist a été vide.',
                            'success'
                        );
                    } else {
                        Swal.fire(
                            'Erreur!',
                            'Une erreur est survenue lors de la suppression des produits.',
                            'error'
                        );
                    }
                }
            });
        }
    });
});

let wishlistQueue = [];
let wishlistProcessing = false;

function fitt_toggleWishlist(productId, $pin = null) {
    wishlistQueue.push({ productId, $pin });
    processNextWishlistAction();
}

function processNextWishlistAction() {
    if (wishlistProcessing || wishlistQueue.length === 0) return;

    wishlistProcessing = true;
    const { productId, $pin } = wishlistQueue.shift();

    if ($pin) {
        $pin.find('.pin-text, .pin-icn').hide();
        $pin.append('<div class="wishlist-loader loader" style="width:20px; height:20px;"></div>');
    }

    $.post('/wp-admin/admin-ajax.php', {
        action: 'toggle_wishlist',
        product_id: productId,
    }, function (response) {
        if ($pin) {
            $pin.find('.wishlist-loader').remove();
            $pin.find('.pin-text, .pin-icn').show();
        }

        if (response.success) {
            let wishlist = fitt_getWishlist();
            let productId_str = String(response.product_id ?? productId); // fallback si pas renvoyé

            if (!wishlist.includes(productId_str)) {
                wishlist.push(productId_str);
            } else {
                wishlist = wishlist.filter(id => id !== productId_str);
            }

            setCookie('interplast_wishlist', wishlist.join(','));
            fitt_refreshWishlist();
        } else {
            console.log(response);
            alert('Veuillez vous connecter pour utiliser la wishlist.');
        }

        // Passe au suivant dans la file
        wishlistProcessing = false;
        processNextWishlistAction();
    });
}